import { CSSProperties } from "react";

interface AnimNumStyles {
  container: (size: number, color: string) => CSSProperties;
  unit: (size: number) => CSSProperties;
}

export const styles: AnimNumStyles = {
  container: (size, color) => ({
    fontSize: `${size}px`,
    fontWeight: "bold",
    color: color,
    fontVariantNumeric: "tabular-nums", // 確保數字寬度一致，跳動時不抖動
  }),
  unit: (size) => ({
    fontSize: `${size * 0.5}px`,
    fontWeight: 500,
    opacity: 0.5,
    marginLeft: "2px",
  }),
};
